import React from 'react';
import BaseStage from '../BaseStage/BaseStage';
import PrimarySectionHeader from 'commonComponents/Headers/PrimarySectionHeader/PrimarySectionHeader';
import SectionHeader from 'commonComponents/Headers/SectionHeader/SectionHeader';
import styles from './PrimaryStage.module.scss';

const PrimaryStage = ({ title, subtitle, type = 'normal', pageName }) => {
  let header;

  if (type === 'normal') {
    header = 
      <PrimarySectionHeader
        header={ subtitle }
        subheader={ title }
        isMajor={ true }
      />;
  } else if (type === 'simple') {
    header = 
      <SectionHeader
        title={ title }
        subtitle={ subtitle }
        isPrime={ true }
      />;
  }

  return (
    <BaseStage pageName={ pageName }>
      <div className={ styles.PrimaryStage }>
        { header }
      </div>
    </BaseStage>
  );
};
 
export default PrimaryStage;